export const CARRIER_PREORDERS = '/v2/carrier-preorders/';
export const PREORDER_BY_ID_STATUS_CLOSED = (id: number): string => `/v1/carrier-preorders/${id}/status/closed`;
export const PREORDER_BY_ID = (id: number): string => `/v2/carrier-preorders/${id}/`;
export const PREORDER_BY_ID_DELETE = (id: number): string => `/v1/carrier-preorders/${id}/`;
export const PREORDER_BY_ID_UPDATE = (id: string): string => `/v2/carrier-preorders/${id}/update`;
export const PREORDER_MATCHED_REQUEST_STATUSES = '/v1/preorder-matched-request-status-types/';
export const PREORDER_MATCHED_STATUS_AND_NOTE = '/v1/preorder-matched-requests/status-and-note';
